import $ from 'jquery';

export const setupFanchoice = (): void => {
  const $fanchoiceForm = $('.fanchoice-submit-form');

  window.setTimeout(() => {
    $('.fanchoice-submit-form .sf-FileField-input').each(function initFileField(this: HTMLElement) {
      const $input = $(this);
      const $label = $input.next('label');
      const labelVal = $label.html();

      $input.on('change', function onFileChange(e: JQuery.ChangeEvent<HTMLInputElement>) {
        const input = this as HTMLInputElement;
        let fileName = '';

        if (input.files && input.files.length > 1) {
          fileName = (input.getAttribute('data-multiple-caption') || '').replace(
            '{count}',
            String(input.files.length),
          );
        } else if (e.target?.value) {
          fileName = e.target.value.split('\\').pop() ?? '';
        }

        if (fileName) {
          $label.text(fileName);
        } else {
          $label.text(labelVal ?? '');
        }
      });

      $input
        .on('focus', () => {
          $input.addClass('has-focus');
        })
        .on('blur', () => {
          $input.removeClass('has-focus');
        });
    });
  }, 500);

  $fanchoiceForm
    .find(".step-1 .input-row[data-sf-role='multiple-choice-field-container'] .input-field")
    .each(function initCategorySlider(this: HTMLElement) {
      const $field = $(this);
      let width = 0;
      let translate = 0;

      $field.children().each(function measureChild(this: HTMLElement) {
        width += $(this).width() ?? 0;
        $(this).attr('data-translate', String(translate));
        translate += 304;
      });

      let $currentCategorySlide = $field.find('.radio:first-child');
      $currentCategorySlide.addClass('active');
      $field.css('width', width);

      $(
        "<button class='slider-arrow previous' type='button'><span class='visuallyhidden'>Previous</span></button>",
      ).insertBefore(
        $fanchoiceForm.find(
          ".step-1 .input-row[data-sf-role='multiple-choice-field-container'] .input-field",
        ),
      );
      $(
        "<button class='slider-arrow next' type='button'><span class='visuallyhidden'>Next</span></button>",
      ).insertAfter(
        $fanchoiceForm.find(
          ".step-1 .input-row[data-sf-role='multiple-choice-field-container'] .input-field",
        ),
      );

      $fanchoiceForm.find('.slider-arrow').on('click', function onArrowClick(this: HTMLElement) {
        const $arrow = $(this);
        const prevTranslate = $currentCategorySlide.prev().data('translate');
        const nextTranslate = $currentCategorySlide.next().data('translate');

        if ($arrow.hasClass('previous') && $currentCategorySlide.prev().length > 0) {
          $field.css('transform', `translate3d(-${prevTranslate}px, 0px, 0px)`);
          $currentCategorySlide = $currentCategorySlide.prev().addClass('active');
          $currentCategorySlide.next().removeClass('active');
        }

        if ($arrow.hasClass('next') && $currentCategorySlide.next().length > 0) {
          $field.css('transform', `translate3d(-${nextTranslate}px, 0px, 0px)`);
          $currentCategorySlide = $currentCategorySlide.next().addClass('active');
          $currentCategorySlide.prev().removeClass('active');
        }

        if ($currentCategorySlide.prev().length <= 0) {
          $field.find('.slider-arrow.previous').addClass('disabled');
        } else {
          $field.find('.slider-arrow.previous').removeClass('disabled');
        }

        if ($currentCategorySlide.next().length <= 0) {
          $field.find('.slider-arrow.next').addClass('disabled');
        } else {
          $field.find('.slider-arrow.next').removeClass('disabled');
        }
      });
    });

  $(".fanchoice-submit-form [class*='step-']").each(function initStep(this: HTMLElement) {
    const $step = $(this);

    window.setTimeout(() => {
      if ($step.hasClass('step-1')) {
        $step.attr('id', 'step1');
        $step.append("<a href='#step2' class='jump-link'>Step 2</a>");
        $step.find("input[type='radio'] + label").on('click', () => {
          $step.find('.jump-link').fadeIn();
        });
      }
      if ($step.hasClass('step-2')) {
        $step.attr('id', 'step2');
        $step.append("<a href='#step3' class='jump-link'>Step 3</a>");
        $step.find("input[type='file']").on('change', function onFileChange(this: HTMLInputElement) {
          if ($(this).val()) {
            $step.find('.jump-link').fadeIn();
          }
        });
      }
      if ($step.hasClass('step-3')) {
        $step.attr('id', 'step3');
      }

      $step.find('.jump-link').on('click', function onJumpLink(this: HTMLAnchorElement) {
        const $target = $($(this).attr('href') ?? '');
        $(this).fadeOut('slow');
        $('html, body').animate(
          {
            scrollTop: ($target.offset()?.top ?? 0) - 96,
          },
          1000,
        );
        return false;
      });
    }, 500);
  });

  if ($('.fanchoice-submit-form').length > 0) {
    $(window).on('scroll', function onFanchoiceScroll(this: Window) {
      const scrollTop = $(this).scrollTop() ?? 0;
      const $step1 = $('.fanchoice-submit-form .step-1');
      const $step2 = $('.fanchoice-submit-form .step-2');
      const step2offset = $step2.offset()?.top ?? 0;
      const step3offset = $('.fanchoice-submit-form .step-3').offset()?.top ?? 0;

      if (scrollTop >= step2offset) {
        $step1.find('.jump-link').fadeOut('fast');
      }
      if (scrollTop >= step3offset) {
        $step2.find('.jump-link').fadeOut('fast');
      }
    });
  }
};
